import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ngx-logo-svg',
  templateUrl: './logo-svg.component.html',
  styleUrls: ['./logo-svg.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LogoSvgComponent {
  constructor() {}
}
